export const siteName = "校园吃瓜日报";
export const siteSlogan = "今日瓜速递 · 校园八卦新鲜事";
export const contactEmail = "contact@gua-campus.example";

export interface NavItem {
  label: string;
  href: string;
}

export const navItems: NavItem[] = [
  { label: "今日热搜榜", href: "#hot-rank" },
  { label: "校园新鲜事", href: "#fresh" },
  { label: "话题分类", href: "#topics" },
  { label: "吃瓜广场", href: "#plaza" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export const ticker = [
  "傍晚教学楼前的一场快闪告白，围观人数破三百，当事双方回应了",
  "南区食堂新档口「冒菜西施」排队排到门外，好评与吐槽齐飞",
  "社团文化节要来了，据说有摊位已经备好了整箱西瓜等大家开瓜",
  "期末互助群深夜还在答疑，校图书馆通宵座位今晚又约满了",
];

export const trendingWords = [
  "抢课系统",
  "社团招新",
  "快递失窃",
  "图书馆占座",
  "外卖失联",
  "期末周",
  "深夜食堂",
];

export interface HotItem {
  rank: number;
  title: string;
  category: string;
  heat: number;
  delta: "up" | "down" | "new" | "keep";
  hotTag: string;
}

export const hotRank: HotItem[] = [
  {
    rank: 1,
    title: "北门水果摊老板娘每天多送半斤，背后是给考研学子的悄悄加油",
    category: "暖闻",
    heat: 98420,
    delta: "new",
    hotTag: "爆",
  },
  {
    rank: 2,
    title: "图书馆顶层「神秘自习桌」连续两周被同一人占走，评论区吵翻了",
    category: "宿舍",
    heat: 87150,
    delta: "up",
    hotTag: "热",
  },
  {
    rank: 3,
    title: "社团招新现场惊现「帮拿快递五分钟换一罐酸奶」服务，被赞大学生商机",
    category: "社团",
    heat: 76320,
    delta: "up",
    hotTag: "热",
  },
  {
    rank: 4,
    title: "南区食堂冒菜新档口开业，有人一天三顿排队，也有人说口味一般",
    category: "食堂",
    heat: 64210,
    delta: "keep",
    hotTag: "议",
  },
  {
    rank: 5,
    title: "深夜操场慢跑「搭子群」爆满，本以为是恋爱瓜，结果是自律打卡",
    category: "生活",
    heat: 53980,
    delta: "down",
    hotTag: "议",
  },
  {
    rank: 6,
    title: "期中作业互改环节闹出的「复制粘贴」名场面，老师当众点名",
    category: "课堂",
    heat: 42130,
    delta: "new",
    hotTag: "瓜",
  },
  {
    rank: 7,
    title: "表白墙一整晚连发三条，都是同一个人对同一位学姐的深情小作文",
    category: "恋爱",
    heat: 35670,
    delta: "up",
    hotTag: "瓜",
  },
];

export type FreshCategory = "全部" | "课堂" | "宿舍" | "恋爱" | "社团" | "食堂" | "校园";

export interface FreshItem {
  id: string;
  category: Exclude<FreshCategory, "全部">;
  title: string;
  summary: string;
  time: string;
  views: string;
  comments: number;
  isNew?: boolean;
  tag: string;
}

export const freshList: FreshItem[] = [
  {
    id: "f1",
    category: "课堂",
    title: "高数老师点名神器竟是一位同学自己写的小程序，全班惊呆",
    summary:
      "这学期老师用小程序随机点名，后来大家才知道代码出自本班一位程序员大佬，前排同学当场喊出「求大佬带飞」。",
    time: "12 分钟前",
    views: "3.2w",
    comments: 208,
    isNew: true,
    tag: "名场面",
  },
  {
    id: "f2",
    category: "宿舍",
    title: "宿舍楼下深夜修车摊，宿管大爷的隐藏技能被同学们挖了出来",
    summary:
      "新搬来的研究生说车胎被扎，大爷十分钟搞定还不要钱，最后只收了一包瓜子当「修理费」。",
    time: "38 分钟前",
    views: "2.1w",
    comments: 149,
    tag: "暖闻",
  },
  {
    id: "f3",
    category: "恋爱",
    title: "图书馆角落的「错位告白」：送奶茶结果认错了人",
    summary:
      "男生把奶茶放到常坐窗边女生桌上就跑了，结果那其实不是心仪的学姐，评论区已经笑得停不下来。",
    time: "1 小时前",
    views: "5.6w",
    comments: 412,
    isNew: true,
    tag: "甜瓜",
  },
  {
    id: "f4",
    category: "社团",
    title: "汉服社与街舞社同天招新，一个古风一个燃，摊位前人气不相上下",
    summary:
      "据说两边社长暗自较劲了一下午，最后合力发了「文化混搭快闪」，围观群众直呼值回票价。",
    time: "2 小时前",
    views: "1.8w",
    comments: 96,
    tag: "校园",
  },
  {
    id: "f5",
    category: "食堂",
    title: "二楼新开的面馆老板每天限量五十碗，卖完就在黑板上写「明天见」",
    summary:
      "手写黑板成了食堂一景，同学们宁可错过饭点也要蹲守，还有人专门来打卡老板的「一句话心情」。",
    time: "3 小时前",
    views: "4.3w",
    comments: 263,
    tag: "口碑",
  },
  {
    id: "f6",
    category: "校园",
    title: "毕业季跳蚤市场提前开张，「一块钱题库」意外成为最热单品",
    summary:
      "一位学长把四年整理的学习资料低价出清，摊位上围满了低年级同学，据说半小时就被抢空。",
    time: "昨天 21:40",
    views: "2.9w",
    comments: 177,
    tag: "现场",
  },
];

export interface Topic {
  key: string;
  name: string;
  emoji: string;
  desc: string;
  postCount: string;
  accent: boolean;
}

export const topics: Topic[] = [
  {
    key: "class",
    name: "课堂八卦",
    emoji: "📚",
    desc: "点名神器、考场趣事、小组互评名场面",
    postCount: "1860+",
    accent: false,
  },
  {
    key: "dorm",
    name: "宿舍风云",
    emoji: "🛏️",
    desc: "室友日常、门禁故事、深夜食堂小确幸",
    postCount: "1430+",
    accent: false,
  },
  {
    key: "love",
    name: "恋爱甜瓜",
    emoji: "💌",
    desc: "表白墙小作文、错位告白、校园情侣日常",
    postCount: "2090+",
    accent: true,
  },
  {
    key: "club",
    name: "社团天地",
    emoji: "🎭",
    desc: "招新名场面、排练趣事、活动后台爆料",
    postCount: "980+",
    accent: false,
  },
  {
    key: "canteen",
    name: "食堂美食",
    emoji: "🍜",
    desc: "档口新品、老板八卦、排队吐槽大全",
    postCount: "1210+",
    accent: false,
  },
  {
    key: "game",
    name: "比赛竞技",
    emoji: "🏀",
    desc: "球赛名场面、啦啦队幕后、电竞社团日常",
    postCount: "760+",
    accent: true,
  },
];

export interface WallPost {
  id: string;
  name: string;
  content: string;
  time: string;
  likes: number;
  comments: number;
  tag: string;
  liked?: boolean;
}

export const wallPosts: WallPost[] = [
  {
    id: "w1",
    name: "爱吃瓜的柠檬",
    content:
      "北区奶茶店老板似乎记住了每个人的口味，我还没开口他就开始做了，这种被记住的感觉太戳人了，我先磕为敬。",
    time: "今天 16:20",
    likes: 528,
    comments: 64,
    tag: "暖瓜",
  },
  {
    id: "w2",
    name: "课堂观察员",
    content:
      "谁能告诉我，为什么每次老师一说「下面请一位同学回答」，全班瞬间集体低头的画面永远看不腻？这就是校园名场面。",
    time: "今天 15:02",
    likes: 891,
    comments: 132,
    tag: "名场面",
  },
  {
    id: "w3",
    name: "一只想早睡",
    content:
      "宿舍楼下新来的小橘猫已经学会在自习室门口蹭空调了，请问这是不是全校公认的「镇校之宝」？在线等投票。",
    time: "今天 13:45",
    likes: 1204,
    comments: 210,
    tag: "萌瓜",
  },
  {
    id: "w4",
    name: "晚自习路过",
    content:
      "听说明天傍晚操场有大动作？我室友说看见了彩排用的气球，评论区有没有知情同学来给我透个风。",
    time: "今天 11:30",
    likes: 356,
    comments: 88,
    tag: "求瓜",
  },
  {
    id: "w5",
    name: "瓜田里的小狗",
    content:
      "学校宣传栏被贴上了手绘的期末互助地图，标了每个教学楼适合自习的角落，做图的同学也太用心了，手动点赞。",
    time: "今天 09:12",
    likes: 743,
    comments: 45,
    tag: "暖瓜",
  },
  {
    id: "w6",
    name: "等待真相",
    content:
      "水果摊的「考研暖瓜」故事是真的，老板娘说是想给辛苦备考的同学一点点甜。这种瓜我愿意天天吃。",
    time: "昨天 22:40",
    likes: 1603,
    comments: 268,
    tag: "实锤",
  },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "爆料的内容会被求证后再发布吗？",
    a: "会。我们坚持「先求证、再上墙」：涉及具体人、事的内容，我们会尽量与当事人或在场同学核对时间与事实，无法证实的会在标题标注「待核实」，不轻易下结论。",
  },
  {
    q: "我不小心看到了自己的瓜，可以申请删除吗？",
    a: "可以。联系页面底部的投稿邮箱，说明内容与位置，我们核实后会尽快撤下相关稿源，并对发布者做内容提醒，确保传播的是真实与友善的信息。",
  },
  {
    q: "吃瓜广场上的发言需要实名吗？",
    a: "不需要。广场支持匿名围观与发言，我们不会强制展示真实身份。也请大家理性吃瓜，尊重隐私，不进行任何形式的网暴或人身攻击。",
  },
  {
    q: "投稿爆料有什么规则或禁区？",
    a: "凡是真实、有趣、温暖的校园生活都可投稿；涉及他人隐私、名誉、隐私照片或可能引发冲突的内容，我们会主动筛除。玩梗可以，伤害不行。",
  },
  {
    q: "校园吃瓜日报是官方媒体吗？",
    a: "不是。这是一个由校园内容爱好者共同维护的轻娱乐资讯平台，定位是「记录真实校园、传播温暖瞬间」，不代表任何学校或组织的官方立场。",
  },
];

export const principles = [
  {
    title: "真实优先",
    desc: "尽量还原时间与现场，拿不准的瓜先标记「待核实」，不靠标题党收割情绪。",
  },
  {
    title: "隐私第一",
    desc: "涉及姓名、照片、宿舍位置等一律打码与脱敏，绝不让玩笑变成伤害。",
  },
  {
    title: "友善吃瓜",
    desc: "可以调侃名场面，但不对任何人进行网暴与攻击，守护有温度的校园讨论。",
  },
  {
    title: "有删有纠",
    desc: "发现失实或引发误解的内容，第一时间修正与删除，并对读者负责。",
  },
];